module.exports = __webpack_public_path__ + "img/validate_error.6498bdcc.svg";